export default __webpack_public_path__ + "static/media/PowerGrotesk-Medium.30618696.woff";